import { z } from 'zod';
import { OptionalCodeSchema } from './common.schema.js';

export const DepartmentInputSchema = z.object({
  name: z.string().min(1).max(120),
  code: OptionalCodeSchema,
  parentId: z.string().optional().nullable(),
  description: z.string().max(2000).optional().nullable(),
  headId: z.string().optional().nullable(),
});
export type DepartmentInput = z.infer<typeof DepartmentInputSchema>;

export const DepartmentSchema = DepartmentInputSchema.extend({
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Department = z.infer<typeof DepartmentSchema>;

export const DesignationInputSchema = z.object({
  title: z.string().min(1).max(120),
  level: z.number().int().min(0).max(20).optional().nullable(),
  description: z.string().max(2000).optional().nullable(),
});
export type DesignationInput = z.infer<typeof DesignationInputSchema>;

export const DesignationSchema = DesignationInputSchema.extend({
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Designation = z.infer<typeof DesignationSchema>;
